import { v4 as uuid } from 'uuid';

const AssociatedAccountsTable = ({ accounts }) => {
  return (
    <table className="table responsive">
      <thead>
        <tr>
          <th>Account Number</th>
          <th>Business Owner</th>
        </tr>
      </thead>
      <tbody>
        {accounts.map(({ accountNo, bizowner }) => {
          return (
            <tr key={uuid()}>
              <td>{accountNo}</td>
              <td>{bizowner}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default AssociatedAccountsTable;
